import type { SnackInput } from "@/lib/gql/__generated__/graphql";

import type { DesignSnackFormBaseModel } from "../type";

type Props = {
	viewModel: DesignSnackFormBaseModel["ViewModel"];
};

export const viewModelToInput = ({ viewModel }: Props): SnackInput => {
	const {
		availablePlansForHotel,
		description,
		isParentTemplate,
		isPublished,
		hotelID,
		ownerType,
		slug,
		snack,
		snackType,
		thumbnail,
		title,
		uuid,
	} = viewModel;

	const input: SnackInput = {
		hotelID,
		snack,
		uuid,

		availablePlansForHotel: availablePlansForHotel
			? availablePlansForHotel.value?.map((item) => item.value)
			: undefined,
		description: description?.value,
		isParentTemplate: isParentTemplate?.value,
		isPublished: isPublished.value,
		ownerType: ownerType?.value,
		slug: slug?.value,
		snackType: snackType?.value,
		thumbnail: thumbnail?.value,
		title: title?.value,
	} satisfies SnackInput;

	return input;
};
